module.exports = __webpack_public_path__ + "img/mirror34.5dae5372.jpg";